let navigateFunction = null;

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};

export const getNavigateFunction = () => {
  return navigateFunction;
};
